module.exports = __webpack_public_path__ + "static/img/tenz.09d39ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner/tenz.png
// module id = XuHa
// module chunks = 35